import React, { useEffect, useState, useCallback } from "react";
import "./NumberingSeries.css";
import axios from "axios";
import useAuthStore from "../../services/authStore";
import { toastError, toastSuccess } from "../../services/toaster";
import { FaPlus, FaSpinner } from "react-icons/fa";
import backIcon from "../../assets/icons/back.png";
import { useRef } from "react";
export default function NumberingSeries() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const hasFetched = useRef(false);
  const [prefix, setPrefix] = useState("");
  const [fy, setFy] = useState("");

  const token = useAuthStore((state) => state.token);
  const companyId = useAuthStore((state) => state.companyId);
  const API_URL = process.env.REACT_APP_API_URL;

  const generateFY = () => {
    const years = [];
    const currentYear = new Date().getFullYear();

    for (let i = 0; i < 5; i++) {
      const start = currentYear + i;
      const end = (start + 1).toString().slice(-2);
      years.push(`${start}-${end}`);
    }
    return years;
  };

  // ✅ ONLY initial fetch
  const fetchSequences = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/document-sequence/${companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data || []);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        "Failed to fetch sequences";

      toastError(message);
    } finally {
      setLoading(false);
    }
  }, [API_URL, companyId, token]);
  useEffect(() => {
    if (companyId && !hasFetched.current) {
      hasFetched.current = true;
      fetchSequences();
    }
  }, [fetchSequences, companyId]);

  const handleCancel = () => {
    setShowForm(false);
    setPrefix("");
    setFy("");
  };

  const handleSave = async () => {
    if (!prefix || !fy) {
      toastError("Please fill all fields");
      return;
    }

    setSaveLoading(true);

    try {
      const res = await axios.post(
        `${API_URL}/document-sequence/${companyId}`,
        {
          company_id: companyId,
          prefix,
          fy,
          last_number: 0,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      // ✅ IMPORTANT: backend returns updated list
      setData(res.data || []);

      toastSuccess("Sequence Created");
      handleCancel();
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        "Failed to create sequence";

      toastError(message);
    } finally {
      setSaveLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="grade-limit-container">
        <div className="center-loader">
          <FaSpinner className="spinner" />
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="expense-container">
      {!showForm ? (
        <>
          <div className="expense-header">
            <button
              className="add-btn"
              onClick={() => {
                handleCancel();
                setShowForm(true);
              }}
            >
              <FaPlus /> Add Sequence
            </button>
          </div>

          <div className="table-wrapper">
            <table className="expense-table">
              <thead>
                <tr>
                  <th>Prefix</th>
                  <th>Financial Year</th>
                </tr>
              </thead>

              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="2" className="no-data">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  data.map((item) => (
                    <tr key={item.id}>
                      <td>{item.prefix}</td>
                      <td>{item.fy}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div className="expense-form-page">
          <div className="form-content">
            <div className="form-header">
              <button className="circle-back-btn" onClick={handleCancel}>
                <img src={backIcon} alt="back" className="back-icon" />
              </button>
              <h3>Add Sequence</h3>
            </div>

            <div className="sequence-scroll-inner-body">
              <div className="sequence-form-row">
                <div className="sequence-form-group">
                  <label>
                    Prefix <span className="sequence-required-star">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Prefix"
                    value={prefix}
                    onChange={(e) => setPrefix(e.target.value.toUpperCase())}
                  />
                </div>

                <div className="sequence-form-group">
                  <label>
                    Financial Year{" "}
                    <span className="sequence-required-star">*</span>
                  </label>
                  <select value={fy} onChange={(e) => setFy(e.target.value)}>
                    <option value="">Select FY</option>
                    {generateFY().map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button className="cancel-btn" onClick={handleCancel}>
                Cancel
              </button>

              <button
                className="save-btn"
                onClick={handleSave}
                disabled={saveLoading}
              >
                {saveLoading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
